import React from "react";

import { TiEyeOutline } from "react-icons/ti";
import { RiCustomerService2Fill } from "react-icons/ri";

import TooltipLite from "react-tooltip-lite";

import { GrUpdate } from "react-icons/gr";
import {
  copyTextToClipboard,
  formatNumberForIndia,
} from "../../utils/comman/Common";

import { useSelector } from "react-redux";
import moment from "moment";

const TransactionList = ({
  table,
  // dataLoading,
  calculateTimeDifference,
  getTodaytDateTime,
  userTimeZone,
  showMerchnat,
  checkTxnIsnotFake,
  utrLeng,
  REQID,
  TXNID,
  UTR,
  ODRCODE,
  handleCallBack,
  showAllData,
  toast,
  primaryColor,
  MdContentCopy,
  selectedTranxtForIssue,
}) => {
  const checkNumber = (value) => {
    if (typeof value === 'number') {
      return true
    } else {
      return false
    }
  }
  const roles = useSelector((state) => state.authReducer?.auth?.roles);
  const mid = useSelector((state) => state?.setMerchantIdReducer?.mid?.id);
  return (
    <div className="txn-list" id="recntxn">
      {
        table !== undefined && table !== null && table.length === 0 ? (
          <h6>No Record Found</h6>
        ) : (
          table?.map((data) => {
            return (
              <div className="txn-item" key={data.id}>
                <div className="txn-head" id="txnhead1">
                  <div
                    className="collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#txn1"
                    aria-expanded="false"
                    aria-controls="txn1"
                  >
                    <div
                      // className={`txncard ${data.status === "SUCCESS_AUTO" ||
                      //     data.status === "SUCCESS_MANUAL" ||
                      //     data.status === "SUCCESS_INCOMPLETE" ||
                      //     data.status === "SUCCESS_FROM_FAILED"
                      //     ? "success grbg"
                      //     : `${data.status === "PENDING_PAYMENT" ||
                      //       data.status === "PAYMENT_PROCESSED" ||
                      //       data.status === "ACCEPTED" ||
                      //       data.status === "TIMEOUT"
                      //       ? "pending ylbg"
                      //       : "failed rdbg"
                      //     }`
                      //   }`}
                      className={`txncard ${!data.debit
                        ? "success grbg"
                        : "failed rdbg"
                        }`}
                    >
                      <div className="row">
                        <div className="col-12 col-md-2">
                          <div className="txntxt">
                            <h6>
                              <span>

                                {data?.createdOn
                                  .replace("T", " ")
                                  .slice(0, -4)}{" "}

                              </span>{" "}
                            </h6>
                            <h6>
                              {/* {data.status === "SUCCESS_AUTO" ||
                              data.status === "SUCCESS_MANUAL"
                              ? calculateTimeDifference(
                                data?.createdOn,
                                data?.updatedOn,
                                userTimeZone
                              )
                              : calculateTimeDifference(
                                data?.createdOn,
                                getTodaytDateTime(),
                                userTimeZone
                              )} */}
                              {
                                data?.ref
                              }
                            </h6>
                            {/* <h6>{data?.receivingVpa}</h6> */}
                            {/* <h6 data-tooltip-id="txn-tooltip-vpa" data-tooltip-content={`${showAccountName(data?.receivingVpa)}`}>
                                      {data?.receivingVpa}
                                      </h6> */}
                          </div>
                        </div>

                        <div className={`col-12 col-md-4`}>
                          <div
                            className="txntxt"
                            onClick={() =>
                              copyTextToClipboard(
                                utrLeng(data?.utr),
                                toast
                              )
                            }
                          >
                            <h5>
                              <h6>
                                UTR: {utrLeng(data?.utr)}

                                <MdContentCopy style={{ color: primaryColor }} />
                              </h6>
                            </h5>
                          </div>
                          <div
                            className="txntxt"
                            onClick={() =>
                              copyTextToClipboard(
                                checkTxnIsnotFake(data?.id, data, TXNID),
                                toast
                              )
                            }
                          >
                            <h5>
                              <h6>
                                TxnID: {checkTxnIsnotFake(data?.id, data, TXNID)}{" "}
                                <MdContentCopy style={{ color: primaryColor }} />
                              </h6>
                            </h5>
                          </div>
                        </div>
                        <div className="col-12 col-md-2">
                          <div className="txntxt">
                            <h6>Amount:  ₹ {checkNumber(data?.amount) && formatNumberForIndia(data?.amount)} </h6>
                            <h6

                            >
                              Deduction:  ₹ {checkNumber(data?.deduction) && formatNumberForIndia(data?.deduction)}
                            </h6>
                          </div>
                        </div>
                        <div
                          // className="col-12 col-md-3"
                          className="col-12 col-md-2"
                        >
                          <div className="txntxt">
                            <h6>Final Amount:  ₹ {checkNumber(data?.finalAmount) && formatNumberForIndia(data?.finalAmount)} </h6>
                            <h6>Balance:  ₹ {checkNumber(data?.balance) && formatNumberForIndia(data?.balance)} </h6>
                          </div>
                        </div>

                        <div className="col-12 col-md-2">
                          <div className="txntxt">
                            <h4>
                              {data.type}
                            </h4>
                            <h4>
                              <span
                                className={`${!data?.debit
                                  ? "success"
                                  : "failed"}`}
                              >
                                {data?.debit ? "Debit" : "Credit"}
                              </span>

                            </h4>

                            {/* )} */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        )}
    </div>
  );
};

export default TransactionList;
